module.exports = __webpack_public_path__ + "static/media/docCheck.3f208040.svg";